import { throttle } from 'lodash';
import * as React from 'react';

import './InfiniteList.css';

const BLOCK = 'infinite-list';

export interface InfiniteListProps {
    content: JSX.Element;
    scrollAtBottom: () => void;
}

export class InfiniteList extends React.PureComponent<InfiniteListProps> {
    private scrollContainer: HTMLDivElement;

    render() {
        return (
            <div className={BLOCK} ref={this.onRef} onScroll={throttle(this.onScroll, 500)}>
                {this.props.content}
            </div>
        );
    }

    private onRef = (ref: HTMLDivElement) => (this.scrollContainer = ref);

    private onScroll = () => {
        const div = this.scrollContainer;
        const isAtBottom = div.scrollHeight - div.scrollTop === div.clientHeight;

        if (isAtBottom) {
            this.props.scrollAtBottom();
        }
    };
}
